module.exports = __webpack_public_path__ + "static/media/26-9.1c33e9f8.mp3";